export const objectIterator = (object) => {
  let resultArray = [];
  for (let item in object) {
    resultArray.push(`${item}: ${object[item]}`);
  }
  return resultArray;
};
